import React, { useEffect, useState } from 'react';
import { fetchAllModules } from '../../../requests/learning';
import Carousel from '../TrainingCarousel';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import { AppHeader } from '../../../app/common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';
import { Wrapper, Cards, Content, HeaderContainer } from './Quizzes.styled';

const Quizzes = () => {
  const { t } = useTranslation();
  const [modules, setModules] = useState<any>(undefined);
  useEffect(() => {
    (async () => {
      const data = await fetchAllModules();
      const filteredData = data.filter(
        (module: { name: string }) => module.name !== 'Emotional Intelligence'
      );
      setModules(filteredData);
    })();
  }, []);

  return (
    <Wrapper>
      <HeaderContainer>
        <AppHeader
          title={t('COMMON.LEARNING.TITLES.QUIZZES')}
          hasBackButton={true}
        />
      </HeaderContainer>
      <Cards>
        <Content>
          {!modules ? (
            <LoadingContent layout="flex" />
          ) : (
            modules.map((module) => (
              <Carousel
                key={module.id}
                showScores={true}
                data={module}
                cardNavigatePath="/learning/quizzes/take-quiz"
              />
            ))
          )}
        </Content>
      </Cards>
    </Wrapper>
  );
};

export default Quizzes;
